import AuthGuard from "app/auth/AuthGuard";
import { MatxLayout } from "app/components";
import attendanceRoutes from "app/views/attendance/AttendanceRoutes";
import areaRoutes from "app/views/configuration/area/AreaRoutes";
import departmentRoutes from "app/views/configuration/department/DepartmentRoutes";
import designationRoutes from "app/views/configuration/designation/DesignationRoutes";
import dailyPlanRoutes from "app/views/configuration/dailyPlan/DailyPlanRoutes";
import feedTypeRoutes from "app/views/configuration/feedType/FeedTypeRoutes";
import monthlyPlanRoutes from "app/views/configuration/monthlyPlan/MonthlyPlanRoutes";
import territoryRoutes from "app/views/configuration/territory/TerritoryRoutes";
import tourPlanRoutes from "app/views/configuration/tourPlan/TourPlanRoutes";
import visitDayRoutes from "app/views/configuration/visitDay/VisitDayRoutes";
import zoneRoutes from "app/views/configuration/zone/ZoneRoutes";
import fishSpeciesRoutes from "app/views/configuration/fishSpecies/FishSpeciesRoutes";
import waterColourRoutes from "app/views/configuration/waterColour/WaterColourRoutes";
import tentativeDiagnosisRoutes from "app/views/configuration/tentativeDiagnosis/TentativeDiagnosisRoutes";
import companyRoutes from "app/views/configuration/company/CompanyRoutes";
import dashboardRoutes from "app/views/dashboard/DashboardRoutes";
import dealerRoutes from "app/views/Dealer/DealerRoutes";
import dealerVisitRoutes from "app/views/DealerVisit/DealerVisitRoutes";
import farmerRoutes from "app/views/Farmer/FarmerRoutes";
import coccidialStatusRoutes from "app/views/configuration/coccidialStatus/CoccidialStatusRoutes";
import farmManagementConditionRoutes from "app/views/configuration/farmManagementCondition/FarmManagementConditionRoutes";
import litterConditionRoutes from "app/views/configuration/litterCondition/LitterConditionRoutes";
import farmTypeRoutes from "app/views/FarmType/FarmTypeRoutes";
import farmVisitRoutes from "app/views/FarmVisit/FarmVisitRoutes";
import fishFarmVisitRoutes from "app/views/FishFarmVisit/FishFarmVisitRoutes";
import feedCompanyRoutes from "app/views/FeedCompany/FeedCompanyRoutes";
import marketingOfficerWiseFarmVisitRoutes from "app/views/MarketingOfficerWiseFarmVisit/MarketingOfficerWiseFarmVisitRoutes";
import roleRoutes from "app/views/Role/roleRoutes";
import NotFound from "app/views/sessions/NotFound";
import sessionRoutes from "app/views/sessions/SessionRoutes";
import userRoutes from "app/views/User/user.route";
import workScheduleRoutes from "app/views/WorkSchedule/WorkScheduleRoutes";
import { Navigate } from "react-router-dom";
import pondRoutes from "./views/configuration/pond/PondRoutes";

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...dashboardRoutes,
      ...dealerVisitRoutes,
      ...userRoutes,
      ...roleRoutes,
      ...dealerRoutes,
      ...farmerRoutes,
      ...feedCompanyRoutes,
      ...farmTypeRoutes,
      ...coccidialStatusRoutes,
      ...farmManagementConditionRoutes,
      ...litterConditionRoutes,
      ...farmVisitRoutes,
      ...fishFarmVisitRoutes,
      ...marketingOfficerWiseFarmVisitRoutes,
      ...attendanceRoutes,
      ...departmentRoutes,
      ...designationRoutes,
      ...feedTypeRoutes,
      ...zoneRoutes,
      ...fishSpeciesRoutes,
      ...waterColourRoutes,
      ...tentativeDiagnosisRoutes,
      ...companyRoutes,
      ...tourPlanRoutes,
      ...monthlyPlanRoutes,
      ...dailyPlanRoutes,
      ...visitDayRoutes,
      ...areaRoutes,
      ...territoryRoutes,
      ...workScheduleRoutes,
      ...pondRoutes,
    ],
  },
  ...sessionRoutes,
  { path: "/", element: <Navigate to="dashboard/default" /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
